import React from "react";
import CountdownTimer from "components/countdown-timer";
import useTimer from "hooks/useTimer";
import clsx from "clsx/lite";
import { ReactComponent as Badge } from "assets/svgs/rounded-badge.svg";
import { useSettings } from "hooks/useStore";

const SaleBanner = ({ sliceContext, previewData }) => {
	const data = previewData || sliceContext || {};
	const { isClient } = useSettings(["isClient"]);
	if (!data.showBanner || !data.text) return null;

	const styledBanner = { backgroundColor: data.bgColor?.hex, color: data.textColor?.hex };

	const timerData = data.countdownTimer || {};
	const { timer, active } = useTimer({ startDate: timerData.startDate, endDate: timerData.endDate, showDays: timerData.showDays });

	const ValueProps = () => (
		<div className={clsx("md:col-span-1 flex md:flex-row flex-row-reverse flex-wrap gap-2 md:gap-5",
			active && isClient ? "justify-center" : "justify-start")}>
			{data.valueProps.map((prop, index) => (
				<div key={index} className="flex items-center gap-1 md:gap-2">
					<Badge className="[&>rect]:fill-beige w-3.5 md:w-4 [&>path]:stroke-black" />
					<span className="text-white text-xs">{prop}</span>
				</div>
			))}
		</div>
	);

	return (
		<div style={styledBanner} className="px-4 md:px-6 py-2">
			<div className={clsx("flex md:w-fit md:m-auto flex-col items-center justify-center md:gap-x-5 md:grid md:grid-cols-2",
				active && isClient ? "gap-2" : "gap-1")}>
				<p className="md:col-span-1 flex justify-end font-bold text-base md:text-xl text-center md:text-left">{data.text}</p>
				{active && isClient && (
					<div className="md:col-span-1 md:row-span-2 flex justify-center md:justify-start">
						<CountdownTimer timer={timer} compactView />
					</div>
				)}
				{data.valueProps && <ValueProps />}
			</div>
		</div>
	);
};

export default SaleBanner;